module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "h1",
    staticStyle: {
      "color": "#82a339"
    },
    attrs: {
      "id": "d7e1200240"
    }
  }, [_c('b', [_vm._v("POKER CHIPS")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e1200740"
    }
  }, [_c('b', [_c('i', [_vm._v("Save on cleanup by lining the cookie sheets with heavy-duty foil or parchment paper.")])])]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    staticStyle: {
      "color": "#496210"
    },
    attrs: {
      "id": "d7e1201840"
    }
  }, [_c('b', [_vm._v("Prep: 10 minutes plus cooling     Bake: 8 minutes")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1202340"
    }
  }, [_vm._v("½ cup olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1203240"
    }
  }, [_vm._v("1 tablespoon freshly grated Parmesan "), _c('br'), _vm._v(" or Pecorino-Romano cheese")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1203840"
    }
  }, [_vm._v("1 tablespoon chili powder")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1204240"
    }
  }, [_vm._v("1 teaspoon ground cumin")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1204540"
    }
  }, [_vm._v("1 package (12 ounces) white or "), _c('br'), _vm._v(" whole-wheat pitas")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    staticStyle: {
      "margin-top": "1.5em"
    },
    attrs: {
      "id": "d7e1205340"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("1.")])]), _vm._v(" Preheat oven to 425°F. In cup, with fork, mix oil, Parmesan, chili powder, and cumin.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1206340"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("2.")])]), _vm._v(" With knife or kitchen shears, carefully split each pita. Brush insides of pita halves lightly with oil mixture. Cut each half into 8 wedges.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1207740"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("3.")])]), _vm._v(" Transfer pita wedges to two ungreased cookie sheets (wedges can overlap slightly). Place cookie sheets on two oven racks and bake pita chips until edges are golden, 8 to 10 minutes. Watch carefully, as they can burn quickly.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1209740"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("4.")])]), _vm._v(" Transfer cookie sheets to wire racks and cool completely. Store chips in airtight container up to 1 week. Makes 8 dozen chips.")]), _vm._v(" "), _c('p', {
    staticClass: "ntx",
    attrs: {
      "id": "d7e1211340"
    }
  }, [_vm._v("Each chip: About 20 calories, 0g protein, 2g carbohydrate, 1g total fat (0g saturated), 0mg cholesterol, 20mg sodium.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7774bdda","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/West_9781618371621_epub_c29_r1.vue
// module id = 153
// module chunks = 0